// extracted by mini-css-extract-plugin
export default {"container":"CheckboxInput_container__rwJ4S","round":"CheckboxInput_round__a-ErH","hiddenLabel":"CheckboxInput_hiddenLabel__YkSIm"};